<template>

    <div class="row">

        <div class="col-sm-8 pb-3">
            <div class="row">

                <div class="col-sm-12">

                    <label>
                        Name <span class="color-6">*</span>
                        <span v-if="$v.reservation.customer.name.$error" class="color-6">
                            <span v-if="!$v.reservation.customer.name.required">Required</span>
                        </span>
                    </label>


                    <div class="d-flex mb-2">
                        <!-- <v-select
                        v-if="getNamePrefixList"
                            taggable
                            class="glued-right"
                            v-model="selectedPrefix"
                            :options="getNamePrefixList"
                            :searchable="false"
                            label="description"
                            placeholder="- Select title -"
                            @input="updatePrefix">
                        </v-select> -->

                        <input type="text" class="full" v-model="reservation.customer.name" @input="$v.reservation.customer.name.$touch">
                    </div>

                </div>

                <div class="col-sm-6">
                    <label>Country</label>

                    <v-select
                        v-model="selectedCountry"
                        :options="getCountries"
                        label="name"
                        placeholder="- Select country -"
                        class="mb-2"
                        @input="updateCountry">
                    </v-select>
                </div>

                <div class="col-sm-6">
                    <label>
                        Phone Number
                    </label>

                    <div class="d-flex mb-2">
                        <input type="text" class="flexGrow1" v-model="reservation.customer.phone" style="min-width: 0;">
                    </div>
                </div>

                <div class="col-sm-12">
                    <label>
                        Email
                        <span v-if="$v.reservation.customer.email.$error" class="color-6">
                            <span v-if="!$v.reservation.customer.email.email">Invalid</span>
                        </span>
                    </label>

                    <input type="email" class="full mb-2" v-model="reservation.customer.email" @input="$v.reservation.customer.email.$touch">
                </div>

                <div class="col-sm-8">
                    <label>Hotel</label>
                    <input type="text" class="full" v-model="reservation.customer.accomodation">
                </div>

                <div class="col-sm-4">
                    <label>Room</label>
                    <input type="text" class="full" v-model="reservation.customer.room">
                </div>

            </div>
        </div>

        <div class="col-sm-4 pb-3 flex-column">
            <div class="row h-100">

                <div class="col-sm-12 d-flex flex-column">
                    <label>Notes</label>
                    <textarea class="h-100" v-model="reservation.note" ></textarea>
                </div>

            </div>

        </div>

    </div>

</template>

<script>
import extendedVSelect from '@/extends/vue-select'
import {mapGetters} from 'vuex'
import { required, email, minLength } from 'vuelidate/lib/validators'

export default {
    data: function() {
        return {
            notes: null,
            selectedPrefix: null,
            defaultCountry: null,
            selectedCountry: null,
        }
    },
    props: {
        reservation: {
            type: Object
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    validations: {
        reservation:{
            customer: {
                name: {
                    required
                },
                email: {
                    email
                }
            }
        }
    },
    created: function() {
        this.setDefaults();
        this.selectedCountry = this.defaultCountry;

        this.selectedPrefix = this.getNamePrefixList[0];
        if(!this.reservation.customer.phone){
            this.reservation.customer.phone = ''
        }
    },
    computed: {
        ...mapGetters([
            'getCountries',
            'getNamePrefixList'
        ]),
        isCustomerInvalid: function() {
            this.reservation.customer.isInvalid = this.$v.$invalid;
            return this.$v.$invalid
        }
    },
    methods: {
        setDefaults: function() {
            this.defaultCountry = this.getCountries.find(i => i.default === true);
            // this.defaultLanguage = this.getLanguages.find(i => i.default === true);

            //if there is no default tries to populate with the country from reservation (if loading reservation)
            if(this.reservation.customer && this.reservation.customer.country) {
                this.defaultCountry = this.getCountries.filter(storedCountry => {
                    return storedCountry.id == this.reservation.customer.country
                })[0]
            }

            // In case we didn't find a default: true
            if (this.defaultCountry === undefined) {
                this.defaultCountry = this.getCountries[0];
            }

        },
        updateCountry: function() {
            let chosen = this.getCountries.find(i => { return i.id === (this.selectedCountry.id) });

            if (chosen) {
                if(this.reservation.customer.phone == "" || this.reservation.customer.phone.length <= 6 ){
                    this.reservation.customer.phone = '+'+chosen.dial+' '
                }

                this.reservation.customer.country = chosen.id
                this.$set(this.reservation.customer, 'dial', chosen.dial)
            }
        },
        updatePrefix: function() {
            this.reservation.customer.prefix = this.selectedPrefix.id
        },
    },
    components:{
        vSelect: extendedVSelect
    }
}
</script>

<style lang="scss" scoped>
@import "../../../../../assets/scss/_variables.scss";
input, textarea{
    background-color: $lighter;
}
</style>



// WEBPACK FOOTER //
// CustomerDetails.vue?a7826816